import {
    isMobile,
    useWindowSize,
} from '@frontend/jetlend-web-ui/src/utils/responsive';
import React from 'react';
import Section from '@app/ui/Section/Section';
import CoursesSection from '../../courses/CoursesSection';
import FeaturesSection from './FeaturesSection/FeaturesSection';
import {
    IAchievementItemApiModel,
    ICourseInformationApiModel,
} from '@app/models/features/course';

export interface IProps {
    /**
     * WP фича-блоки
     */
    blocks: any[];
    /**
    * Список ачивок
    */
    achievements: IAchievementItemApiModel[];
    /**
    * Список всех курсов
    */
    courses: ICourseInformationApiModel[];
}

/**
 * Компонент для отрисовки середины страницы академии
 */
const MainSection:React.FC<IProps> = props => {
    const {
        achievements,
        courses,
        blocks,
    } = props;
    const features = blocks?.find(item => item.type === 'features');
    const { width } = useWindowSize();
    const isMobileScreen = isMobile(width);

    return (
        <>
            <Section filled={false} animation={false} stretch={isMobileScreen ? 'horizontally' : undefined}>
                <CoursesSection
                    achievements={achievements}
                    courses={courses}
                    whiteCards
                />
            </Section>
            <FeaturesSection features={features} />
        </>
    );
};

export default MainSection;